import Tooltip, {
    type TooltipProps,
    tooltipClasses,
} from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {},
}));
